"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = void 0;
var defaultProps = {
  color: 'primary70',
  fontWeight: 'medium',
  textDecoration: 'underline'
};
exports.defaultProps = defaultProps;